import { useCallback, useState } from "react";

import { Button, Col, Col1, Form, TextTitle } from "../lib";
import { City, User, useUserCityAreasUpdate } from "../services";
import { CityAreaInput } from "./city-area-input";
import { createStyles, sizes } from "../theme";

type Props = {
  city: City;
  onSuccess: () => void;
  user: User;
};

export function CityAreasForm({ city, onSuccess, user }: Props) {
  // Data
  const [updateUserCityAreas] = useUserCityAreasUpdate();
  const [areaIds, setAreaIds] = useState<number[]>(
    user.areas.map((area) => area.id)
  );

  // Handlers
  const handleSubmit = useCallback(async () => {
    await updateUserCityAreas({ areas: areaIds });

    onSuccess();
  }, [updateUserCityAreas, areaIds, onSuccess]);

  const handleChange = useCallback((areaId: number, active: boolean) => {
    setAreaIds((prev) => {
      const newAreaIds = prev.filter((id) => id !== areaId);

      if (active) {
        newAreaIds.push(areaId);
      }

      return newAreaIds;
    });
  }, []);

  // Render
  return (
    <Form>
      <Col1>
        <TextTitle mb="4">{city.name}</TextTitle>
        <Col style={$.content}>
          {(city.areas ?? []).map((area) => (
            <CityAreaInput
              key={`area-${area.id}`}
              id={area.id}
              name={area.name}
              value={areaIds.includes(area.id)}
              onChange={handleChange}
            />
          ))}
        </Col>
      </Col1>

      <Button onPress={handleSubmit}>Save changes</Button>
    </Form>
  );
}

const $ = createStyles({
  content: {
    gap: sizes["4"],
  },
});
